/**
 * @generated SignedSource<<24b832db5ee8797604ac1b7c637aef57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
export type useRunningBuildUpdaterRelayQuery$variables = {
  locator: string;
};
export type useRunningBuildUpdaterRelayQuery$data = {
  readonly build: {
    readonly agent: {
      readonly connected: boolean | null | undefined;
    } | null | undefined;
    readonly artifacts: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly buildTypeId: string | null | undefined;
    readonly canceledInfo: {
      readonly text: string | null | undefined;
      readonly timestamp: string | null | undefined;
      readonly user: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly rawId: number | null | undefined;
        readonly username: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly detachedFromAgent: boolean | null | undefined;
    readonly finishOnAgentDate: string | null | undefined;
    readonly number: string | null | undefined;
    readonly personal: boolean | null | undefined;
    readonly runningInfo: {
      readonly currentStageText: string | null | undefined;
      readonly elapsedSeconds: number | null | undefined;
      readonly estimatedTotalSeconds: number | null | undefined;
      readonly lastActivityTime: string | null | undefined;
      readonly leftSeconds: number | null | undefined;
      readonly outdated: boolean | null | undefined;
      readonly outdatedReasonBuild: {
        readonly links: {
          readonly link: ReadonlyArray<{
            readonly relativeUrl: string | null | undefined;
          }> | null | undefined;
        } | null | undefined;
        readonly number: string | null | undefined;
        readonly rawId: number | null | undefined;
      } | null | undefined;
      readonly percentageComplete: number | null | undefined;
      readonly probablyHanging: boolean | null | undefined;
    } | null | undefined;
    readonly state: BuildState | null | undefined;
    readonly status: string | null | undefined;
    readonly statusText: string | null | undefined;
    readonly testOccurrences: {
      readonly count: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useRunningBuildUpdaterRelayQuery = {
  response: useRunningBuildUpdaterRelayQuery$data;
  variables: useRunningBuildUpdaterRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buildTypeId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentageComplete",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elapsedSeconds",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimatedTotalSeconds",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "leftSeconds",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentStageText",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "probablyHanging",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastActivityTime",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outdated",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Links",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Link",
      "kind": "LinkedField",
      "name": "link",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relativeUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "canceledInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusText",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detachedFromAgent",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finishOnAgentDate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personal",
  "storageKey": null
},
v22 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Files",
  "kind": "LinkedField",
  "name": "artifacts",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "TestOccurrences",
  "kind": "LinkedField",
  "name": "testOccurrences",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRunningBuildUpdaterRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgressInfo",
            "kind": "LinkedField",
            "name": "runningInfo",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Build",
                "kind": "LinkedField",
                "name": "outdatedReasonBuild",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v3/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentRest",
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              (v25/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRunningBuildUpdaterRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgressInfo",
            "kind": "LinkedField",
            "name": "runningInfo",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Build",
                "kind": "LinkedField",
                "name": "outdatedReasonBuild",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v3/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentRest",
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac63c7118ae21b3562a1323300f859e9",
    "id": null,
    "metadata": {},
    "name": "useRunningBuildUpdaterRelayQuery",
    "operationKind": "query",
    "text": "query useRunningBuildUpdaterRelayQuery(\n  $locator: String!\n) {\n  build(buildLocator: $locator) {\n    buildTypeId\n    number\n    runningInfo {\n      percentageComplete\n      elapsedSeconds\n      estimatedTotalSeconds\n      leftSeconds\n      currentStageText\n      probablyHanging\n      lastActivityTime\n      outdated\n      outdatedReasonBuild {\n        rawId\n        number\n        links {\n          link {\n            relativeUrl\n          }\n        }\n        id\n      }\n    }\n    canceledInfo {\n      timestamp\n      text\n      user {\n        id\n        rawId\n        name\n        username\n      }\n    }\n    statusText\n    status\n    state\n    detachedFromAgent\n    finishOnAgentDate\n    personal\n    artifacts {\n      count\n    }\n    testOccurrences {\n      count\n    }\n    agent {\n      connected\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e7d8008258ef7737b016c29a0589cf9";

export default node;
